<template>
  <div>
    <div id="Server">
      <video
        class="video_box"
        v-if="serverBack.type == '2'"
        :src="serverBack.video"
        autoplay
        loop
        muted
      ></video>
      <img
        :src="serverBack.image"
        v-if="serverBack.type == '1'"
        class="backImg_box"
        alt=""
      />
      <div class="server">
        <div
          class="item_box"
          v-for="(item, index) in floor_pip"
          :key="index"
          @click="toDetail(item, index)"
        >
          <div class="en">{{ item.en }}</div>
          <div class="line"></div>
          <div class="zh">{{ item.zh }}</div>
          <div class="more">MORE ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      floor_pip: [
        {
          en: "TIANYUAN PIPELINE",
          zh: "天原管道",
        },
        {
          en: "FLOOR CHANGER",
          zh: "仟领地板",
        },
      ],
      serverBack: {},
    };
  },
  methods: {
    toDetail(item, index) {
      // console.log(item)
      this.$router.push({
        path: "/serverDetail",
        query: {
          type: index + 1,
        },
      });
    },
  },
  mounted() {
    if (this.baclgroundInfo.length === 0) {
      setTimeout(() => {
        var obj = this.baclgroundInfo;
        this.serverBack = obj[3];
      }, 500);
    } else {
      var obj = this.baclgroundInfo;
      this.serverBack = obj[3];
    }
  },
  computed: {
    baclgroundInfo() {
      return this.$store.state.baclgroundInfo;
    },
  },
};
</script>

<style scoped lang='scss'>
#Server {
  width: 100%;
  height: 100vh;
  background: #1a1a1a;
  // background-image: url("../../assets/indexImg/Serveer_back.png");
  background-size: cover;
  position: relative;
  .video_box {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 0;
    width: 100vw;
    height: 100%;
  }
  .backImg_box {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 0;

  }
  .server {
    z-index: 2;
    // width: 1530px;
    width:79.68vw;
    min-width: 1200px;
    // height: 226px;
    height: 22.6vh;
    margin: 0 auto;
    // position: absolute;
    // top: 407px;
    // left: 10vw;
    // padding-top: 407px;
    padding-top: 40.7vh;
    display: flex;
    justify-content: space-between;
    .item_box {
      width: 590px;
      height: 100%;
      transition: all 0.5s;
      z-index: 9;
      .en {
        font-size: 38px;
        font-family: Arial;
        font-weight: bold;
        // line-height: 42px;
        line-height: 4.2vh;
        // color: rgba(255, 255, 255, 0.2);
        color: #ffffff;
        text-align: center;
        // margin: 40px 0 12px 0;
        margin: 4vh 0 1.2vh 0;
        letter-spacing: 8px;
      }
      .line {
        width: 80px;
        height: 2px;
        // background-color: rgba(255, 255, 255, 0.2);
        background-color: #ffffff;
        margin: 0 auto;
      }
      .zh {
        font-size: 30px;
        font-family: Microsoft JhengHei;
        font-weight: 400;
        // line-height: 40px;
        line-height: 4vh;
        // color: rgba(255, 255, 255, 0.2);
        color: #ffffff;
        text-align: center;
        // margin: 10px 0 20px 0;
        margin: 1vh 0 2vh 0;
        letter-spacing: 10px;
      }
      .more {
        font-size: 18px;
        font-family: Arial;
        font-weight: 400;
        // line-height: 20px;
        line-height: 2vh;
        color: transparent;
        text-align: center;
        letter-spacing: 5px;
      }
    }
    .item_box:hover {
      width: 590px;
      height: 100%;
      background: rgba(15, 255, 255, 0.1);
      border: 1px solid #0fffff;
      cursor: url("../../assets/cursor.png"), none;
      transition: all 0.5s;
      .en {
        font-size: 38px;
        font-family: Arial;
        font-weight: bold;
        // line-height: 42px;
        line-height: 4.2vh;
        color: #0fffff;
        text-align: center;
        // margin: 40px 0 12px 0;
        margin: 4vh 0 1.2vh 0;
        letter-spacing: 8px;
      }
      .line {
        width: 80px;
        height: 2px;
        background: #0fffff;
        margin: 0 auto;
      }
      .zh {
        font-size: 30px;
        font-family: Microsoft JhengHei;
        font-weight: 400;
        // line-height: 40px;
        line-height: 4vh;
        color: #0fffff;
        text-align: center;
        // margin: 10px 0 20px 0;
        margin: 1vh 0 2vh 0;
        letter-spacing: 10px;
      }
      .more {
        font-size: 18px;
        font-family: Arial;
        font-weight: 400;
        // line-height: 20px;
        line-height: 2vh;
        color: #0fffff;
        text-align: center;
        letter-spacing: 5px;
      }
    }
  }
}
</style>